export const checkTitle = "BindPage.CheckModal.title";
export const createBtn = "BindPage.CheckModal.createButton";
export const bindBtn = "BindPage.CheckModal.bindButton";
